import React from 'react';
import { IconButton } from '@mui/material';
import IconFontAwesome, {
  IconFontAwesomeProps,
} from 'new/components/IconFontAwesome';

type Props = {
  name: IconFontAwesomeProps['name'];
  onClick: () => void;
  color?: IconFontAwesomeProps['color'];
  disabled?: boolean;
};

const TableActionButton: React.FC<Props> = ({
  name,
  onClick,
  disabled = false,
  color = 'primaryDark',
}) => (
  <IconButton onClick={onClick} disabled={disabled}>
    <IconFontAwesome name={name} color={color} size="xs" />
  </IconButton>
);

export default TableActionButton;
